import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=1da7ad0b&scoped=true"
import script from "./registerDialog.vue?vue&type=script&lang=js"
export * from "./registerDialog.vue?vue&type=script&lang=js"
import style0 from "./registerDialog.vue?vue&type=style&index=0&id=1da7ad0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da7ad0b",
  null
  
)

export default component.exports